import { NgModule, ErrorHandler } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { HttpClientModule, HttpClient } from '@angular/common/http';
import { AgGridModule } from 'ag-grid-angular';
import { TranslateModule, TranslateLoader } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { NgChartsModule } from 'ng2-charts';
import { Chart, registerables } from 'chart.js';
import zoomPlugin from 'chartjs-plugin-zoom';
import { registerChartDefaults } from './shared/chart-link.plugin';

import { SharedModule } from './shared/shared.module';
import { AppRoutingModule } from './app-routing.module';
import { RootComponent } from './root.component';
import { AppComponent } from './app.component';
import { PopupCardComponent } from './popup-card/popup-card.component';
import { SparklineChartComponent } from './sparkline-chart/sparkline-chart.component';
import { SolarChartComponent } from './solar-chart/solar-chart.component';
import { GlobalErrorHandler } from './error-log.service';
import { COMMIT_HASH } from '../version';
import { EnergieComponent } from './energie/energie.component';
import { KlimaComponent } from './klima/klima.component';
import { KnxComponent } from './knx/knx.component';
import { KnxRoomsComponent } from './knx/knx-rooms.component';
import { KnxSwitchesComponent } from './knx/knx-switches.component';
import { KnxBlindsComponent } from './knx/knx-blinds.component';
import { KnxWeatherComponent } from './knx/knx-weather.component';
import { MuellComponent } from './muell/muell.component';
import { NetzwerkComponent } from './netzwerk/netzwerk.component';
import { StatistikComponent } from './statistik/statistik.component';
import { HourlyChartComponent } from './hourly-chart/hourly-chart.component';
import { HeizungComponent } from './heizung/heizung.component';
import { HeizungChartComponent } from './heizung-chart/heizung-chart.component';
import { ZisterneComponent } from './zisterne/zisterne.component';
import { AdminKnxComponent } from './admin-knx/admin-knx.component';
import { AdminCamsComponent } from './admin-cams/admin-cams.component';
import { AdminKnxValvesComponent } from './admin-knx/admin-knx-valves.component';
import { BoardComponent } from './board/board.component';
import { BoardChartComponent } from './board/board-chart.component';

Chart.register(...registerables, zoomPlugin);
registerChartDefaults();

export function createTranslateLoader(http: HttpClient) {
  return new TranslateHttpLoader(http, './assets/i18n/', `.json?v=${COMMIT_HASH}`);
}

@NgModule({
  declarations: [
    RootComponent,
    AppComponent,
    PopupCardComponent,
    SparklineChartComponent,
    SolarChartComponent,
    EnergieComponent,
    KlimaComponent,
    KnxComponent,
    KnxRoomsComponent,
    KnxSwitchesComponent,
    KnxBlindsComponent,
    KnxWeatherComponent,
    MuellComponent,
    NetzwerkComponent,
    StatistikComponent,
    HourlyChartComponent,
    HeizungComponent,
    HeizungChartComponent,
    ZisterneComponent,
    AdminKnxComponent,
    AdminCamsComponent,
    AdminKnxValvesComponent,
    BoardComponent,
    BoardChartComponent,
  ],
  imports: [
    BrowserModule,
    CommonModule,
    FormsModule,
    HttpClientModule,
    AgGridModule,
    NgChartsModule,
    SharedModule,
    AppRoutingModule,
    TranslateModule.forRoot({
      defaultLanguage: 'en',
      loader: {
        provide: TranslateLoader,
        useFactory: createTranslateLoader,
        deps: [HttpClient]
      }
    })
  ],
  providers: [
    { provide: ErrorHandler, useClass: GlobalErrorHandler }
  ],
  bootstrap: [RootComponent]
})
export class AppModule { }
